import { Modelo } from '@ext/index';
import moment, { Moment } from 'moment';
import { isObject } from 'util';
import { Viajante } from '@/__env/lib/Ventas/Viajantes/Viajante.nav';
import { Articulo } from '@/__env/lib/Articulos';
import * as Pedidos from '../';
import { Pedido } from '@/__env/lib/Ventas/Pedidos/Pedido.nav';

export class IResumenPedidos extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Tipo: string;
    public Datos: IEstadiscia = {}

    public set(): boolean
    {

        this.Datos = this.Json;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IResumenPedidos )
    {
        this.Model = Model;
    }
    public Model: IResumenPedidos;
}


export interface IEstadiscia
{
    pendientes?: Pendientes;
    preparando?: Preparando;
    despachados?: Despachados;
    finalizados?: Ados;
}

export interface Ados
{
    total?: number;
}

export interface Pendientes
{
    total?: number;
    importe?: number;
    detalles?: PendientesDetalles;
    transportes?: Transporte[];
}

export interface Preparando
{
    total?: number;
    importe?: number;
    detalles?: PreparandoDetalles;
    hojas?: Hoja[];
    transportes?: Transporte[];
}

export interface Despachados
{
    total?: number;
    detalles?: DespachadosDetalles;
    transportes?: Transporte[];
}

export interface PendientesDetalles
{
    demorados?: number;
    "despachar-hoy"?: number;
    "mercado-envios"?: number;
    "mercado-envios-flex"?: number;
    "mercado-envios-full"?: number;
    "envio-no-acordado"?: number;
    "retira-cliente"?: number;
    "envio-gratis"?: number;
    "envio-propio"?: number;
    "contra-entrega"?: number;
}


export interface PreparandoDetalles
{
    facturados?: number;
    no_facturados?: number;
    demorados?: number;
    "despachar-hoy"?: number;
    "mercado-envios"?: number;
    "mercado-envios-flex"?: number;
    "envio-no-acordado"?: number;
    "retira-cliente"?: number;
    "envio-gratis"?: number;
    "envio-propio"?: number;
    "contra-entrega"?: number;
}

export interface DespachadosDetalles
{
    devueltos?: number;
}




export interface Hoja
{
    total?: number;
    hoja?: number;
}


export interface Transporte
{
    total?: number;
    codigo?: string;
    descripcion?: string;
}
